import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class UserTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "User Settings" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'IP Address Logging', descriptionColumn: 'When activated the IP address of every user that logs in to your cameras video stream will be logged. Check your cameras System Log' },
        { actionColumn: 'Admin name', descriptionColumn: 'This is the name and password for the administrator login. The administrator has access to all functions of the camera. The default is admin/instar. The login will be set to a personal username and password during the initial setup wizard steps.' },
        { actionColumn: 'User name', descriptionColumn: 'This is the name and password for the regular user login. The user has access to the video stream and can also pan & tilt your camera (only PTZ cameras). The configuration menu will not be available. Deactivated by default.' },
        { actionColumn: 'Guest name', descriptionColumn: 'This is the name and password for a guest login. The guest only has access to the video stream. Deactivated by default.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

UserTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(UserTable)